<template>
  <div class="pedidos-listado">

    <!-- Cabecera -->
    <div class="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
      <h5 class="mb-0 fw-semibold" style="color:var(--text-primary)">
        <i class="bi bi-bag-check me-2" style="color:var(--primary-main)"></i>Gestión de Pedidos
      </h5>
      <button class="btn btn-sm btn-primary" @click="$router.push('/ventas/pedidos/nuevo')">
        <i class="bi bi-plus-circle me-1"></i>Nuevo Pedido
      </button>
      <button
        class="btn btn-sm btn-outline-secondary"
        @click="configMensaje.panelVisible = !configMensaje.panelVisible"
        title="Configurar mensaje de imagen de pedido"
      >
        <i class="bi bi-gear me-1"></i>Mensaje imagen
      </button>
    </div>

    <!-- Panel: Configuración del mensaje de imagen -->
    <div v-if="configMensaje.panelVisible" class="card shadow-sm mb-3 border-warning" style="background:var(--secondary-bg-main)">
      <div class="card-body py-3">
        <h6 class="mb-1 fw-semibold" style="color:var(--text-primary)">
          <i class="bi bi-chat-square-text me-1" style="color:#f59e0b"></i>Mensaje al pie de la imagen del pedido
        </h6>
        <p class="text-secondary small mb-2">
          Este texto aparece al final de la imagen que el vendedor comparte desde la app móvil.
          Úsalo para indicar condiciones de cobro o avisos legales.
        </p>
        <textarea
          v-model="configMensaje.texto"
          class="form-control form-control-sm mb-2"
          rows="3"
          maxlength="1000"
          placeholder="Ej: Los cobros se realizan únicamente por transferencia bancaria o contra-entrega. El vendedor no está autorizado para recibir dinero en efectivo. La empresa no se responsabiliza por pagos efectuados directamente al vendedor."
        ></textarea>
        <div class="d-flex gap-2 justify-content-end">
          <button class="btn btn-sm btn-outline-secondary" @click="configMensaje.panelVisible = false">Cancelar</button>
          <button class="btn btn-sm btn-warning text-white" @click="guardarMensajePedido" :disabled="configMensaje.guardando">
            <span v-if="configMensaje.guardando" class="spinner-border spinner-border-sm me-1"></span>
            <i v-else class="bi bi-save me-1"></i>Guardar mensaje
          </button>
        </div>
      </div>
    </div>

    <!-- Filtros -->
    <div class="card shadow-sm mb-3" style="background:var(--secondary-bg-main);border:1px solid var(--border-main)">
      <div class="card-body py-2 px-3">
        <div class="row g-2 align-items-end">
          <div class="col-6 col-md-2">
            <label class="form-label small mb-1" style="color:var(--text-secondary)">Estado</label>
            <select class="form-select form-select-sm" v-model="filtros.estado" @change="cargarPedidos"
                    style="background:var(--bg-main);color:var(--text-primary);border-color:var(--border-main)">
              <option value="">Todos</option>
              <option value="pendiente">Pendiente</option>
              <option value="confirmado">Confirmado</option>
              <option value="en_preparacion">En preparación</option>
              <option value="listo">Listo</option>
              <option value="entregado">Entregado</option>
              <option value="cancelado">Cancelado</option>
              <option value="pagado">Pagado</option>
              <option value="facturado">Facturado</option>
            </select>
          </div>
          <div class="col-6 col-md-2">
            <label class="form-label small mb-1" style="color:var(--text-secondary)">Origen</label>
            <select class="form-select form-select-sm" v-model="filtros.origen" @change="cargarPedidos"
                    style="background:var(--bg-main);color:var(--text-primary);border-color:var(--border-main)">
              <option value="">Todos</option>
              <option value="app_movil">App Móvil</option>
              <option value="web">Web</option>
            </select>
          </div>
          <div class="col-6 col-md-2">
            <label class="form-label small mb-1" style="color:var(--text-secondary)">Desde</label>
            <input type="date" class="form-control form-control-sm" v-model="filtros.fecha_desde" @change="cargarPedidos"
                   style="background:var(--bg-main);color:var(--text-primary);border-color:var(--border-main)">
          </div>
          <div class="col-6 col-md-2">
            <label class="form-label small mb-1" style="color:var(--text-secondary)">Hasta</label>
            <input type="date" class="form-control form-control-sm" v-model="filtros.fecha_hasta" @change="cargarPedidos"
                   style="background:var(--bg-main);color:var(--text-primary);border-color:var(--border-main)">
          </div>
          <div class="col-12 col-md-2 d-flex gap-2">
            <button class="btn btn-sm btn-outline-secondary flex-fill" @click="limpiarFiltros">
              <i class="bi bi-x-circle me-1"></i>Limpiar
            </button>
            <button class="btn btn-sm btn-primary flex-fill" @click="cargarPedidos" :disabled="cargando">
              <i class="bi bi-search me-1"></i>Buscar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Error -->
    <div v-if="errorMensaje" class="alert alert-danger d-flex align-items-center gap-2 mb-3 py-2">
      <i class="bi bi-exclamation-triangle-fill"></i>
      <span>{{ errorMensaje }}</span>
      <button type="button" class="btn-close ms-auto" @click="errorMensaje = ''"></button>
    </div>

    <!-- Tabla -->
    <div class="card shadow-sm" style="background:var(--secondary-bg-main);border:1px solid var(--border-main)">
      <div class="card-body p-0">
        <div v-if="cargando" class="text-center py-5" style="color:var(--text-muted)">
          <div class="spinner-border spinner-border-sm me-2"></div>Cargando pedidos...
        </div>
        <div v-else-if="pedidos.length === 0" class="text-center py-5" style="color:var(--text-muted)">
          <i class="bi bi-inbox fs-2 d-block mb-2"></i>No hay pedidos para los filtros seleccionados.
        </div>
        <div v-else class="table-responsive">
          <table class="table table-sm table-hover mb-0">
            <thead style="background:var(--bg-main)">
              <tr style="color:var(--text-secondary);font-size:.78rem">
                <th class="ps-3">N° Pedido</th>
                <th>Origen</th>
                <th>Cliente</th>
                <th>Vendedor</th>
                <th>Fecha</th>
                <th class="text-end">Total</th>
                <th class="text-center">Estado</th>
                <th class="text-center pe-3">Acciones</th>
              </tr>
            </thead>
            <tbody style="font-size:.82rem">
              <tr v-for="p in pedidos" :key="p.id">
                <td class="ps-3 fw-semibold" style="color:var(--text-primary)">{{ p.numero_pedido }}</td>
                <td>
                  <span class="badge" :class="p.origen === 'app_movil' ? 'bg-info text-dark' : 'bg-secondary'">
                    <i :class="p.origen === 'app_movil' ? 'bi bi-phone' : 'bi bi-display'" class="me-1"></i>
                    {{ p.origen === 'app_movil' ? 'Móvil' : 'Web' }}
                  </span>
                </td>
                <td style="color:var(--text-primary)">{{ p.cliente_nombre }}</td>
                <td style="color:var(--text-secondary)">{{ p.vendedor_nombre }}</td>
                <td style="color:var(--text-secondary)">{{ formatearFecha(p.created_at) }}</td>
                <td class="text-end fw-semibold" style="color:var(--accent-success)">{{ dinero(p.total) }}</td>
                <td class="text-center">
                  <span class="badge" :class="badgeEstado(p.estado)">{{ labelEstado(p.estado) }}</span>
                </td>
                <td class="text-center pe-3">
                  <div class="d-flex gap-1 justify-content-center">
                    <button class="btn btn-xs btn-outline-primary" title="Ver detalle" @click="$router.push('/ventas/pedidos/' + p.id)">
                      <i class="bi bi-eye"></i>
                    </button>
                    <button
                      v-if="p.estado === 'pendiente'"
                      class="btn btn-xs btn-outline-warning"
                      title="Editar pedido"
                      @click="$router.push('/ventas/pedidos/' + p.id + '/editar')">
                      <i class="bi bi-pencil"></i>
                    </button>
                    <button
                      v-if="p.estado !== 'cancelado' && p.estado !== 'facturado' && p.estado !== 'pagado'"
                      class="btn btn-xs btn-outline-secondary"
                      title="Cambiar estado"
                      @click="abrirModalEstado(p)">
                      <i class="bi bi-arrow-left-right"></i>
                    </button>
                    <button
                      v-if="p.estado !== 'cancelado' && p.estado !== 'facturado'"
                      class="btn btn-xs btn-success"
                      title="Convertir a factura"
                      @click="iniciarConversion(p)">
                      <i class="bi bi-receipt-cutoff me-1"></i>Facturar
                    </button>
                    <span v-if="p.estado === 'facturado'" class="text-success small">
                      <i class="bi bi-check-circle-fill me-1"></i>Facturado
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- ── Modal: Cambiar estado ── -->
    <div v-if="modalEstado.visible" class="modal-overlay" @click.self="modalEstado.visible = false">
      <div class="modal-caja" style="max-width:420px">
        <div class="modal-header-caja d-flex align-items-center justify-content-between">
          <span class="fw-semibold" style="color:var(--text-primary)">
            <i class="bi bi-arrow-left-right me-2" style="color:var(--primary-main)"></i>Cambiar Estado
          </span>
          <button class="btn-close-caja" @click="modalEstado.visible = false">✕</button>
        </div>
        <div class="modal-body-caja">
          <p class="small mb-2" style="color:var(--text-secondary)">
            Pedido: <strong style="color:var(--text-primary)">{{ modalEstado.pedido && modalEstado.pedido.numero_pedido }}</strong>
          </p>
          <div class="mb-3">
            <label class="form-label small" style="color:var(--text-secondary)">Nuevo estado</label>
            <select class="form-select form-select-sm" v-model="modalEstado.nuevoEstado"
                    style="background:var(--bg-main);color:var(--text-primary);border-color:var(--border-main)">
              <option value="pendiente">Pendiente</option>
              <option value="confirmado">Confirmado</option>
              <option value="en_preparacion">En preparación</option>
              <option value="listo">Listo</option>
              <option value="entregado">Entregado</option>
              <option value="pagado">Pagado</option>
              <option value="cancelado">Cancelado</option>
            </select>
          </div>
          <div v-if="modalEstado.nuevoEstado === 'cancelado'" class="mb-3">
            <label class="form-label small" style="color:var(--text-secondary)">Motivo de cancelación</label>
            <input type="text" class="form-control form-control-sm" v-model="modalEstado.motivo"
                   placeholder="Opcional"
                   style="background:var(--bg-main);color:var(--text-primary);border-color:var(--border-main)">
          </div>
        </div>
        <div class="modal-footer-caja d-flex gap-2 justify-content-end">
          <button class="btn btn-outline-secondary btn-sm" @click="modalEstado.visible = false">Cancelar</button>
          <button class="btn btn-primary btn-sm" @click="ejecutarCambioEstado" :disabled="modalEstado.guardando">
            <span v-if="modalEstado.guardando" class="spinner-border spinner-border-sm me-1"></span>
            Guardar
          </button>
        </div>
      </div>
    </div>

    <!-- ── Modal: Confirmar conversión a factura ── -->
    <div v-if="modalConversion.visible" class="modal-overlay" @click.self="modalConversion.visible = false">
      <div class="modal-caja" style="max-width:440px">
        <div class="modal-header-caja d-flex align-items-center justify-content-between">
          <span class="fw-semibold" style="color:var(--text-primary)">
            <i class="bi bi-receipt-cutoff me-2" style="color:var(--accent-success)"></i>Convertir a Factura
          </span>
          <button class="btn-close-caja" @click="modalConversion.visible = false">✕</button>
        </div>
        <div class="modal-body-caja">
          <div class="alert alert-info py-2 small">
            <i class="bi bi-info-circle me-1"></i>
            Se pre-cargarán los datos del pedido <strong>{{ modalConversion.pedido && modalConversion.pedido.numero_pedido }}</strong>
            en el formulario de facturación. Revise y emita la factura desde allí.
          </div>
          <div v-if="modalConversion.cargando" class="text-center py-3" style="color:var(--text-muted)">
            <div class="spinner-border spinner-border-sm me-2"></div>Preparando datos...
          </div>
          <div v-if="modalConversion.error" class="alert alert-danger py-2 small">{{ modalConversion.error }}</div>
        </div>
        <div class="modal-footer-caja d-flex gap-2 justify-content-end">
          <button class="btn btn-outline-secondary btn-sm" @click="modalConversion.visible = false" :disabled="modalConversion.cargando">Cancelar</button>
          <button class="btn btn-success btn-sm" @click="ejecutarConversion" :disabled="modalConversion.cargando">
            <span v-if="modalConversion.cargando" class="spinner-border spinner-border-sm me-1"></span>
            <i v-else class="bi bi-arrow-right-circle me-1"></i>Ir a Facturación
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import api from '@/services/api'
import { pedidosService } from '@/services/pedidosService'
import notificaciones from '@/services/notificationService.js'

export default {
  name: 'ClientVentasPedidos',

  data() {
    return {
      pedidos:      [],
      cargando:     false,
      errorMensaje: '',

      filtros: {
        estado:      '',
        origen:      '',
        fecha_desde: '',
        fecha_hasta: ''
      },

      modalEstado: {
        visible:     false,
        pedido:      null,
        nuevoEstado: '',
        motivo:      '',
        guardando:   false
      },

      modalConversion: {
        visible:  false,
        pedido:   null,
        cargando: false,
        error:    ''
      },

      configMensaje: {
        panelVisible: false,
        texto:        '',
        guardando:    false
      }
    }
  },

  mounted() {
    this.cargarPedidos()
    this._cargarMensajePedido()
  },

  methods: {
    async cargarPedidos() {
      this.cargando     = true
      this.errorMensaje = ''
      try {
        const filtrosActivos = Object.fromEntries(
          Object.entries(this.filtros).filter(([, v]) => v !== '')
        )
        const res = await pedidosService.listar(filtrosActivos)
        this.pedidos = res.data.data?.pedidos || []
      } catch {
        this.errorMensaje = 'Error al cargar los pedidos.'
      } finally {
        this.cargando = false
      }
    },

    limpiarFiltros() {
      this.filtros = { estado: '', origen: '', fecha_desde: '', fecha_hasta: '' }
      this.cargarPedidos()
    },

    async _cargarMensajePedido() {
      try {
        const res = await api.get('/configuracion/mensaje-pedido')
        this.configMensaje.texto = res.data.data?.mensaje || ''
      } catch { /* silencioso */ }
    },

    async guardarMensajePedido() {
      this.configMensaje.guardando = true
      try {
        await api.put('/configuracion/mensaje-pedido', { mensaje: this.configMensaje.texto })
        notificaciones.success('Mensaje de imagen guardado correctamente.')
        this.configMensaje.panelVisible = false
      } catch {
        notificaciones.error('Error al guardar el mensaje.')
      } finally {
        this.configMensaje.guardando = false
      }
    },

    abrirModalEstado(pedido) {
      this.modalEstado.pedido      = pedido
      this.modalEstado.nuevoEstado = pedido.estado
      this.modalEstado.motivo      = ''
      this.modalEstado.guardando   = false
      this.modalEstado.visible     = true
    },

    async ejecutarCambioEstado() {
      this.modalEstado.guardando = true
      try {
        await pedidosService.cambiarEstado(
          this.modalEstado.pedido.id,
          this.modalEstado.nuevoEstado,
          this.modalEstado.motivo || null
        )
        notificaciones.success('Estado actualizado a "' + this.labelEstado(this.modalEstado.nuevoEstado) + '".')
        this.modalEstado.visible = false
        this.cargarPedidos()
      } catch (e) {
        notificaciones.error((e?.response?.data?.error) || 'Error al cambiar el estado.')
      } finally {
        this.modalEstado.guardando = false
      }
    },

    iniciarConversion(pedido) {
      this.modalConversion.pedido   = pedido
      this.modalConversion.cargando = false
      this.modalConversion.error    = ''
      this.modalConversion.visible  = true
    },

    async ejecutarConversion() {
      this.modalConversion.cargando = true
      this.modalConversion.error    = ''
      try {
        const res   = await pedidosService.convertir(this.modalConversion.pedido.id)
        const datos = res.data.data
        this.modalConversion.visible = false
        // Guardar en sessionStorage para que ClientVentas lo procese al montar
        sessionStorage.setItem('pedido_prefill', JSON.stringify(datos))
        this.$router.push('/ventas/facturacion')
      } catch (e) {
        this.modalConversion.error = (e?.response?.data?.error) || 'Error al obtener los datos del pedido.'
      } finally {
        this.modalConversion.cargando = false
      }
    },

    // ── Helpers ──────────────────────────────────────────────
    dinero(valor) {
      return '$ ' + parseFloat(valor || 0).toFixed(2)
    },

    formatearFecha(fecha) {
      if (!fecha) return '-'
      return new Date(fecha).toLocaleDateString('es-EC', {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit'
      })
    },

    labelEstado(estado) {
      const mapa = {
        pendiente:      'Pendiente',
        confirmado:     'Confirmado',
        en_preparacion: 'En preparación',
        listo:          'Listo',
        entregado:      'Entregado',
        pagado:         'Pagado',
        cancelado:      'Cancelado',
        facturado:      'Facturado'
      }
      return mapa[estado] || estado
    },

    badgeEstado(estado) {
      const mapa = {
        pendiente:      'bg-secondary',
        confirmado:     'bg-primary',
        en_preparacion: 'bg-warning text-dark',
        listo:          'bg-info text-dark',
        entregado:      'bg-success',
        pagado:         'bg-success',
        cancelado:      'bg-danger',
        facturado:      'bg-success'
      }
      return mapa[estado] || 'bg-secondary'
    }
  }
}
</script>

<style scoped>
.pedidos-listado {
  padding: 1.25rem;
  color: var(--text-primary);
}

/* Overlay de modales */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.45);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.modal-caja {
  background: var(--secondary-bg-main);
  border: 1px solid var(--border-main);
  border-radius: .5rem;
  width: 100%;
  box-shadow: var(--shadow-md);
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  overflow: hidden;
}

.modal-header-caja {
  padding: .75rem 1rem;
  border-bottom: 1px solid var(--border-main);
  flex-shrink: 0;
}

.modal-body-caja {
  padding: 1rem;
  overflow-y: auto;
  flex: 1;
}

.modal-footer-caja {
  padding: .75rem 1rem;
  border-top: 1px solid var(--border-main);
  flex-shrink: 0;
}

.btn-close-caja {
  background: none;
  border: none;
  font-size: 1rem;
  cursor: pointer;
  color: var(--text-muted);
  line-height: 1;
  padding: 0;
}
.btn-close-caja:hover {
  color: var(--accent-danger);
}

/* Botón extra-small */
.btn-xs {
  padding: .15rem .4rem;
  font-size: .75rem;
}
</style>
